import $ from "jquery";
import "jquery.scrollto";
import gsap from "gsap";
import BezierEasing from "bezier-easing";
import stage from "../components/stage";
import render from "../components/render";
import slick from "slick-carousel";
import { WOW } from "wowjs/dist/wow";

class Mobile {
  constructor() {
    this.init();
  }

  init() {
    this.renderQue = this.render.bind(this);
    this.resizeQue = this.resize.bind(this);

    this.addEvents();
    console.log("mobile.js loaded");
  }

  startPage() {
    this.body = $("body");
    this.animate = $(".animate");
    this.parallaxvideo = $("#video");
    this.gradient = $(".gradient");
    this.addAnimations();
    stage.on("stage:scroll", this.renderQue);
    stage.on("stage:resize", this.resizeQue);
    this.resize();

    $("#mobile-captions").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: "#mobile-screenshots",
    });

    $("#mobile-screenshots").slick({
      dots: true,
      arrows: false,
      autoplay: true,
      cssEase: "linear",
      fade: true,
      infinite: true,
      appendDots: "#mobile-dots",
      asNavFor: "#mobile-captions",
      focusOnSelect: true,
      // responsive: [
      //   {
      //     breakpoint: 768,
      //     settings: {
      //       arrows: false,
      //       centerMode: true,
      //       centerPadding: "40px",
      //       slidesToShow: 3,
      //     },
      //   },
      //   {
      //     breakpoint: 480,
      //     settings: {
      //       arrows: false,
      //       centerMode: true,
      //       centerPadding: "40px",
      //       slidesToShow: 1,
      //     },
      //   },
      // ],
    });
  }

  addEvents() {
    this.startPage();
  }

  removeEvents() {
    stage.removeListener("stage:scroll", this.renderQue);
    stage.removeListener("stage:resize", this.resizeQue);
  }

  addAnimations() {
    new WOW().init();
  }

  complete() {
    $("html").addClass("initialized");
    this.resize();
  }

  resize(e) {
    if (!e) e = stage;

    this.isMobile = e.w < 768;

    // if(this.isMobile) {
    //   this.tsharevar = 30
    //   this.tshare.invalidate()
    // }
    // else {
    //   this.tsharevar = 90
    //   this.tshare.invalidate()
    // }

    this.animate.each((i, el) => {
      const show = $(el);
      const showrect = show.offset();
      const showheight = show.height();
      const showwidth = show.width();
      const offset = show.data("offset") || 0;

      show.data("bottom", showrect.top + showheight);
      show.data("top", showrect.top + offset);
      show.data("left", showrect.left);
      show.data("width", showwidth);
      show.data("height", showheight);
    });

    // this.parallax.each((i, el) => {
    //   const imgel = $(el)
    //   const rect = imgel.offset()
    //   const height = imgel.height()
    //
    //   imgel.data('top',  rect.top)
    //   imgel.data('height', height)
    //   imgel.data('image', $('.bg', imgel))
    //
    // })

    //2400 = 1
    var max = Math.max(e.w, e.h);
    TweenMax.set(this.gradient, { width: 2 * max, height: 2 * max });

    var angle = this.isMobile
      ? this.getAngleDeg(40, stage.w)
      : this.getAngleDeg(200, stage.w);

    $(".bg").each((index, el) => {
      var sign = el.dataset.orientation || -1;
      TweenMax.set(el, { rotation: sign * angle, force3D: true });
    });

    this.render(e);
  }

  render(e) {
    this.animate.each((i, el) => {
      const show = $(el);
      const showindex = show.data("height");
      const showtoken = show.data("top");
      const showinview =
        e.scrolltop + e.h > showtoken && e.scrolltop < showtoken + showindex;
      const showloading = e.scrolltop <= showtoken - e.h;

      show.toggleClass("in-view", showinview);
      show.toggleClass("hide", showloading);
    });

    if (e.scrolltop > 200) {
      TweenMax.set(this.parallaxvideo, {
        y: -((e.scrolltop - 200) / 5),
        force3D: true,
      });
    } else {
      TweenMax.set(this.parallaxvideo, {
        y: 0,
        force3D: true,
      });
    }
    //
    // if(e.scrolltop > e.h + 100) {
    //   this.video.pause()
    // }
    // else {
    //   this.video.play()
    // }
  }

  getAngleDeg(a, b) {
    var angleRad = Math.atan(a / b),
      angleDeg = (angleRad * 180) / Math.PI;

    return angleDeg;
  }

  destroy() {
    // console.log('destroy page')
  }
}

module.exports = Mobile;
